// Легкий банер cookie: без залежностей. Показується, якщо відсутні prefs або версія інша.
export default defineNuxtPlugin(() => {
  if (typeof window === "undefined") return;

  const VERSION = "v1";
  const host = location.hostname;

  // показуємо банер лише на бойовому/публічному хості
  const isProdHost = [
    "mulberryss.shop",
    "www.mulberryss.shop",
    "localhost",
    "127.0.0.1",
  ].includes(host);
  if (!isProdHost) return;

  const v = localStorage.getItem("cookiePrefsVersion");
  const prefsRaw = localStorage.getItem("cookiePrefs");
  let need = true;
  if (v === VERSION && prefsRaw) need = false;

  if (!need) return;

  // Стилі + HTML
  const css = `
  .cc-wrap{position:fixed;inset:auto 0 0 0;z-index:60;background:#111;color:#fff}
  .cc-inner{max-width:1100px;margin:0 auto;padding:14px 16px;display:flex;gap:12px;align-items:center;flex-wrap:wrap}
  .cc-text{flex:1 1 520px;font-size:12px;line-height:1.5}
  .cc-btn{padding:10px 14px;font-size:12px;border-radius:12px;border:1px solid #fff1;cursor:pointer}
  .cc-accept{background:#fbcfe8;color:#111;border-color:#fbcfe8}
  .cc-link{color:#fbcfe8;text-decoration:underline}
  `;
  const html = `
  <div class="cc-wrap" role="dialog" aria-label="Згода на cookie" aria-describedby="cc-desc" aria-live="polite">
    <div class="cc-inner">
      <div class="cc-text" id="cc-desc">
        Використовуємо cookie для роботи сайту та покращень. Керувати згодою можна на
        <a class="cc-link" href="/cookies">сторінці cookie</a>.
      </div>
      <div class="flex gap-2">
        <button class="cc-btn" id="cc-decline">Лише необхідні</button>
        <button class="cc-btn" id="cc-settings">Налаштувати</button>
        <button class="cc-btn cc-accept" id="cc-accept">Прийняти всі</button>
      </div>
    </div>
  </div>`;

  const style = document.createElement("style");
  style.textContent = css;
  const box = document.createElement("div");
  box.innerHTML = html;

  function setPrefs(p) {
    localStorage.setItem("cookiePrefs", JSON.stringify(p));
    localStorage.setItem("cookiePrefsVersion", VERSION);
    try {
      window.dispatchEvent(new CustomEvent("cookiePrefsUpdated"));
    } catch {}
  }
  function close() {
    box.remove();
    style.remove();
  }

  document.head.appendChild(style);
  document.body.appendChild(box);

  document.getElementById("cc-accept")?.addEventListener("click", () => {
    setPrefs({ analytics: true, marketing: true });
    close();
  });
  document.getElementById("cc-decline")?.addEventListener("click", () => {
    setPrefs({ analytics: false, marketing: false });
    close();
  });
  document.getElementById("cc-settings")?.addEventListener("click", () => {
    setPrefs({ analytics: false, marketing: false });
    close();
    window.location.href = "/cookies";
  });
});
